<template>
  <v-app id="app" :style="appTheme.val">
    <Loader :start="spin.val" style="z-index: 9999999999999999999999999999999 !important" />
    <Loader :start="spin2.val" style="z-index: 9999999999999999999999999999999 !important" />
    <LoaderComponentReport :start="spinReport.val" style="z-index: 9999999999999999999999999999999 !important" />
    <alert-component ref="snackRef" />
    <!-- <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon" /> -->
    <router-view />
  </v-app>
</template>

<script>
import Loader from '@/components/LoaderComponent.vue';
import LoaderComponentReport from '@/components/LoaderComponentReport.vue';
import 'animate.css';
import ThemeHelper from './Helpers/ThemeHelper';
import AlertComponent from '@/components/AlertComponent.vue';
export default {
  name: 'App',
  components: { Loader, AlertComponent, LoaderComponentReport },
  mixins: [ThemeHelper],

  created() {
    this.$root.$refs.appView = this;
    window.addEventListener('beforeunload', function (event) {
      event.returnValue = 'Write something';
    });
  },
  data() {
    return {
      appTheme: {
        val: this.customeTheme,
      },
      spin: {
        val: false,
      },
      spin2: {
        val: false,
      },
      spinReport: {
        val: false,
      },
      table: {
        val: '',
      },
      tableTitleIMG: {
        val: require('@/assets/images/tableTitleIMG.png'),
      },
    };
  },
  provide() {
    return {
      appThemeChange: this.appTheme,
      load: this.spin,
      load2: this.spin2,
      loadReport: this.spinReport,
      tableImg: this.table,
      tableTitleImage: this.tableTitleIMG,
    };
  },
  mounted() {
    this.themConfig();
    // this.broadCastChannel=new BroadcastChannel('--test--')
  },
  methods: {
    themConfig: function () {
      this.appTheme.val = this.customeTheme;
      let theme = localStorage.getItem('theme');
      let width = window.innerWidth;
      if (theme) {
        if (width < 1536) {
          if (theme == 'blue') {
            this.table.val = require('@/assets/images/tabled.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG.png');
          } else if (theme == '2') {
            this.table.val = require('@/assets/images/tabled2.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG2.png');
          } else if (theme == '3') {
            this.table.val = require('@/assets/images/tabled3.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG3.png');
          } else if (theme == '4') {
            this.table.val = require('@/assets/images/tabled4.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG4.png');
          } else if (theme == '5') {
            this.table.val = require('@/assets/images/tabled5.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG5.png');
          } else if (theme == '6') {
            this.table.val = require('@/assets/images/tabled6.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG6.png');
          } else if (theme == '7') {
            this.table.val = require('@/assets/images/tabled7.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG7.png');
          } else if (theme == '8') {
            this.table.val = require('@/assets/images/tabled8.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG8.png');
          }
        } else {
          if (theme == 'blue') {
            this.table.val = require('@/assets/images/table.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG.png');
          } else if (theme == '2') {
            this.table.val = require('@/assets/images/table2.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG2.png');
          } else if (theme == '3') {
            this.table.val = require('@/assets/images/table3.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG3.png');
          } else if (theme == '4') {
            this.table.val = require('@/assets/images/table4.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG4.png');
          } else if (theme == '5') {
            this.table.val = require('@/assets/images/table5.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG5.png');
          } else if (theme == '6') {
            this.table.val = require('@/assets/images/table6.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG6.png');
          } else if (theme == '7') {
            this.table.val = require('@/assets/images/table7.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG7.png');
          } else if (theme == '8') {
            this.table.val = require('@/assets/images/table8.png');
            this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG8.png');
          }
        }
      } else {
        localStorage.setItem('theme', 'blue');
        if (width < 1536) {
          this.table.val = require('@/assets/images/tabled.png');
          this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG.png');
        } else {
          this.table.val = require('@/assets/images/table.png');
          this.tableTitleIMG.val = require('@/assets/images/tableTitleIMG.png');
        }
      }
    },
  },
  // beforeDestroy() {
  //   this.broadCastChannel.close()
  // },
  unmounted() {
    window.removeEventListener('beforeunload', () => {
      this.onSendMessage();
    });
  },
};
</script>

<style>
@font-face {
  font-family: 'a_iranian_sansregular';
  src: url('./assets/fonts/IRANSansWeb.woff') format('woff');
}

@font-face {
  font-family: 'Shekasteh2Beta';
  src: url('./assets/fonts/Shekasteh2Beta.woff') format('woff');
}

@font-face {
  font-family: 'IranNastaliq';
  src: url('./assets/fonts/IranNastaliq.woff') format('woff');
}

@font-face {
  font-family: 'Captcha Code';
  src: url('./assets/fonts/Captchacode.woff') format('woff');
}

@font-face {
  font-family: 'Entezar2';
  src: url('./assets/fonts/Entezar2.woff') format('woff');
}

@font-face {
  font-family: 'Entezar';
  src: url('./assets/fonts/Entezar.woff') format('woff');
}

@font-face {
  font-family: 'Yekan-Bakh-Regular';
  src: url('./assets/fonts/YekanBakhRegular.woff') format('woff');
}

@font-face {
  font-family: 'password';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/password.woff') format('woff');
}

@font-face {
  font-family: 'A.RaiMediaBlack_p30download.com';
  src: url('./assets/fonts/A.RaiMediaBlack_p30download.com.woff') format('woff');
}

@font-face {
  font-family: 'A.Amine_p30download.com';
  src: url('./assets/fonts/A.Amine_p30download.com.woff') format('woff');
}

#app {
  font-family: 'Yekan-Bakh-Regular' !important;
  direction: rtl;
  background-color: var(--background-color) !important;
  letter-spacing: normal;
}

.v-application {
  font-size: 13px !important;
}

.v-label {
  font-size: 12px !important;
  font-family: 'Yekan-Bakh-Regular' !important;
}

.fontFamilySET {
  font-family: 'Yekan-Bakh-Regular' !important;
}

input {
  font-size: 13px !important;
}

>>>.v-list-item__title {
  font-size: 11px !important;
}



@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

>>>main {
  padding: 0px 0px 0px 0px !important;
}

.v-data-table-header tr th {
  color: #212121 !important;
  font-size: 14px !important;
}

.v-data-table__wrapper table tbody tr td {
  font-size: 14px !important;
}

.normal-letter-spacing {
  letter-spacing: normal !important;
}

.v-dialog {
  border-radius: 10px !important;
  z-index: 999 !important;
}

.text-index {
  z-index: 1 !important;
}

.Vue-Toastification__container {
  z-index: 9999999999999999999999999999999 !important;
}

.Vue-Toastification__toast-body {
  font-family: 'Yekan-Bakh-Regular' !important;
}

.vue2leaflet-map {
  border-radius: 7px !important;
}

.table-card {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  border-left: 2px solid #0f7af4 !important;
  border-right: 2px solid #0f7af4 !important;
  border-bottom: 2px solid #0f7af4 !important;
  border-top: none !important;
}

.header-title-content {
  color: white !important;
  font-size: 14px;
}

.header-title {
  margin-top: 2vh !important;
}

.modal-icon {
  margin-top: -7vh !important;
  margin-right: -1vh !important;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.v-snack {
  z-index: 999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999 !important;
}

.Vue-Toastification__container .Vue-Toastification__toast {
  min-width: 140px !important;
}

.Vue-Toastification__container.top-left,
.Vue-Toastification__container.bottom-left {
  left: 3vh !important;
}

.Vue-Toastification__container.top-left,
.Vue-Toastification__container.top-right,
.Vue-Toastification__container.top-center {
  top: 4vh !important;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

td {
  cursor: default !important;
  user-select: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  -khtml-user-select: none !important;
  color: black !important;
}

span {
  user-select: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  -khtml-user-select: none !important;
}

.leaflet-attribution-flag {
  visibility: hidden !important;
}
</style>
